import { route } from "../router/route";

export const customerServiceTabList = [
  { title: "공지사항", path: route.customer_service_notice },
  { title: "1:1 문의", path: route.customer_service_ask },
  { title: "FAQ", path: route.customer_service_faq },
  { title: "이용약관", path: route.customer_service_terms_use },
];

export const askSubTabList = [
  { title: "전체보기", path: route.customer_service_ask },
  { title: "나의 문의 내역", path: route.customer_service_ask_my },
];

export const termsSubTabList = [
  { title: "서비스 이용약관", path: route.customer_service_terms_use },
  { title: "개인정보처리방침", path: route.customer_service_terms_privacy },
];
